import { GetterTree } from "vuex";
import { RootState } from "@/store/type";
import { UiState } from "@/store/ui/type";

export const getters: GetterTree<UiState, RootState> = {
  isLoginModalOpen: (state): any => {
    return state.isLoginModalOpen;
  },
  isMenuModalOpen: (state): boolean => {
    return state.isMenuModalOpen;
  },
  isColissimoModalOpen: (state): any => {
    return state.isColissimoModalOpen;
  },
  isProductsActionModal: (state): any => {
    return state.isProductsActionModal;
  },
  isNoStockActionModal: (state): any => {
    return state.isNoStockActionModal;
  },

  getCurrentLocale: (state): any => {
    return state.currentLocal;
  },
  isAddressModalOpen: (state): boolean => {
    return state.isAddressModalOpen;
  },
  isAddressListModalOpen: (state): boolean => {
    return state.isAddressListModalOpen;
  },
  isSearchOpen: (state): boolean => {
    return state.isSearchOpen;
  },
  isWelcomeModal: (state): any => {
    return state.isWelcomeModal;
  },
  isResetModal: (state): any => {
    return state.isResetModal;
  },
  isCartSidebarOpen: (state): boolean => {
    return state.isCartSidebarOpen;
  },
  getNotifications: (state) => {
    return state.notifications;
  },
  getProductGallery: (state) => {
    return state.productGallery;
  },
  getIndexGallery: (state) => {
    return state.indexGallery;
  },
  getSelectedRelais: (state) => {
    return state.isColissimoModalOpen.selectedRelais;
  },

};